import React from "react";
import { orderStatus, russianMonth } from "../../../util";

const dateFormat = (date) => {
    return `${date.getDate()} ${russianMonth[date.getMonth() + 1].slice(0, 3)}, ${date.getFullYear()}`;
}

const LkDeliveryCard = (props) => {

    const DeliveryCard = props.data.LkDelivery.DeliveryCard;

    console.log(props.el);

    let statusText;
    let statusStyleBg
    let statusStyleColor
    switch (orderStatus(props.el)) {
        case "in_progress":
            statusText = `${props.data.LkDelivery.DeliveryStatuses.process.text}`;
            statusStyleBg = props.data.LkDelivery.DeliveryStatuses.process.bgColor;
            statusStyleColor = props.data.LkDelivery.DeliveryStatuses.process.color;
            break;
        case "done":
            statusText = `${props.data.LkDelivery.DeliveryStatuses.completed.text}`;
            statusStyleBg = props.data.LkDelivery.DeliveryStatuses.completed.bgColor;
            statusStyleColor = props.data.LkDelivery.DeliveryStatuses.completed.color;
            break;
        case "aborted":
            statusText = `${props.data.LkDelivery.DeliveryStatuses.сancelled.text}`;
            statusStyleBg = props.data.LkDelivery.DeliveryStatuses.сancelled.bgColor;
            statusStyleColor = props.data.LkDelivery.DeliveryStatuses.сancelled.color;
            break;
    }


    let typeText;
    let typeImage
    switch (props.el.delivery_type) {
        case "avia":
            typeText = `${props.data.LkDelivery.TypeOrder.avia.text}`;
            typeImage = `${props.data.LkDelivery.TypeOrder.avia.image}`
            break;
        case "auto":
            typeText = `${props.data.LkDelivery.TypeOrder.avto.text}`
            typeImage = `${props.data.LkDelivery.TypeOrder.avto.image}`
            break;
        case "train":
            typeText = `${props.data.LkDelivery.TypeOrder.poezd.text}`
            typeImage = `${props.data.LkDelivery.TypeOrder.poezd.image}`
            break;
        case "ship":
            typeText = `${props.data.LkDelivery.TypeOrder.ship.text}`
            typeImage = `${props.data.LkDelivery.TypeOrder.ship.image}`
            break;
    }

    const maxDeliveryDays = parseInt(props.el.delivery_time.split('-')[1]);
    let finalDate = new Date(props.el.created_at);
    finalDate.setDate(finalDate.getDate() + maxDeliveryDays);

    return (
        <div key={props.el._id} className="sm:w-[32%] w-[100%] sm:min-w-[320px] h-fit p-[16px] sm:p-[24px] rounded-[20px]" style={{ backgroundColor: DeliveryCard.color3 }}>

            <div className="flex items-center justify-between">
                <div>{props.el._id}</div>
                <div className="cursor-pointer p-[6px] rounded-[43px]" style={{
                    backgroundColor: DeliveryCard.btnColor,
                }}>
                    <img src={DeliveryCard.btnImage} />
                </div>
            </div>

            <div className="mt-[20px] text-[14px] flex items-center justify-between">
                <div className=" flex items-center gap-[8px] rounded-[41px] sm:py-[8px] sm:px-[12px] px-[10px] py-[5px]"
                    style={{
                        backgroundColor: DeliveryCard.color1
                    }}>
                    <img src={typeImage} />
                    <span>{typeText} {DeliveryCard.text1}</span>
                </div>
                <div className={` rounded-[25px] sm:py-[8px] sm:px-[16px] py-[5px] px-[10px] font-semibold`}
                    style={{
                        backgroundColor: statusStyleBg,
                        color: statusStyleColor
                    }}>
                    {statusText}
                </div>
            </div>

            <div className="w-[100%] mt-[20px]">
                <img className="w-[100%]" src={DeliveryCard.image} />
            </div>

            <div className="flex items-center justify-between mt-[12px] sm:pb-[24px]  border-b-[2px] border-solid "
                style={{
                    borderColor: DeliveryCard.color1
                }}>
                <div className="text-left">
                    <div className="sm:text-[14px] text-[12px] mb-[4px]"
                        style={{ color: DeliveryCard.color2 }}>{DeliveryCard.text2}</div>
                    <div className="sm:text-[20px] text-[18px]">{dateFormat(new Date(props.el.created_at))}</div>
                </div>
                <div className="text-right">
                    <div className="sm:text-[14px] text-[12px] mb-[4px]" style={{ color: DeliveryCard.color2 }}>{DeliveryCard.text3}</div>
                    <div className="sm:text-[20px] text-[18px]">{dateFormat(finalDate)}</div>
                </div>
            </div>

            <div className="flex items-center justify-between mt-[12px] sm:mt-[24px] sm:pb-[24px]  border-b-[2px] border-solid" style={{ borderColor: DeliveryCard.color1 }}>
                <div className="text-left">
                    <div className="sm:text-[14px] text-[12px] mb-[4px]" style={{ color: DeliveryCard.color2 }}>{DeliveryCard.text4}</div>
                    <div className="sm:text-[20px] text-[18px]">{props.el.weight} кг.</div>
                </div>
                <div className="text-right">
                    <div className="sm:text-[14px] text-[12px] mb-[4px]" style={{ color: DeliveryCard.color2 }}>{DeliveryCard.text5}</div>
                    <div className="sm:text-[20px] text-[18px]">{props.el.volume} куб. м.</div>
                </div>
            </div>

            <div className="flex items-center justify-between mt-[12px] sm:mt-[24px]">
                <div className="text-left">
                    <div className="sm:text-[14px] text-[12px]  mb-[4px]" style={{ color: DeliveryCard.color2 }}>{DeliveryCard.text6}</div>
        { /* TODO: изменить на добавочную стоимость. */ }
                    <div className="sm:text-[20px] text-[18px]">-</div>
                </div>
                <div className="text-center">
                    <div className="sm:text-[14px] text-[12px] mb-[4px]" style={{ color: DeliveryCard.color2 }}>{DeliveryCard.text7}</div>
                    <div className="sm:text-[20px] text-[18px]">-</div>
                </div>
                <div className="text-right">
                    <div className="sm:text-[14px] text-[12px] mb-[4px]" style={{ color: DeliveryCard.color2 }}>{DeliveryCard.text8}</div>
                    <div className="sm:text-[20px] text-[18px]">${props.el.delivery_cost + props.el.invoice_cost}</div>
                </div>
            </div>

        </div>
    )
}

export default LkDeliveryCard;
